<div class="scorecard scorecard-container rounded" (click)="openScorecardDescription()">
  <div class="streak-container">
    <!--Streak Header-->
    <div>
      <h3 class="scorecard-name scorecard-label-ellipsis">{{ scorecard?.Content[0].Name }}</h3>
      <p class="scorecard-description scorecard-label-ellipsis mb-0">{{ scorecard.Content[0].ShortDescription }}</p>
    </div>
    <!--Streak Value-->
    <div class="streak-number-container">
      <div class="d-flex align-items-center streak-progress">
        <h4 class="streak-number-value text-primary mb-0">
          {{ scorecard?.Milestone?.CustomerValue ?? 0 }}
        </h4>

        <img *ngIf="scorecard?.Milestone?.CustomerValue > 0" class="streak-logo" src="assets/images/placeholders/FireIcon.svg" />
      </div>
      <div class="current-streak-info">{{ 'fgbcl.scorecard.current.streak' | translate }}</div>
    </div>
  </div>
  <!--Sponsors-->
  <ng-container *ngIf="scorecard.Sponsor?.SponsorImage">
    <div class="sponsor-img-text">
      <img class="sponsor-img" [src]="scorecard.Sponsor.SponsorImage | contentImage: '30'" />
    </div>
  </ng-container>
</div>
